import { render, staticRenderFns } from "./DashboardUpcoming.vue?vue&type=template&id=4f0df548&scoped=true&"
import script from "./DashboardUpcoming.vue?vue&type=script&lang=ts&"
export * from "./DashboardUpcoming.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardUpcoming.vue?vue&type=style&index=0&id=4f0df548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0df548",
  null
  
)

export default component.exports